"use client";
import type { SelectType } from "@/types";
import { setIcon } from "@/utils";
import { Listbox, Transition } from "@headlessui/react";
import Image from "next/image";
import { twMerge } from "tailwind-merge";

interface SelectInputProps {
    active: string;
    onChange: (value: string) => void;
    initialOption?: SelectType;
    options: SelectType[];
}

export default function SelectInput({
    active,
    onChange,
    initialOption,
    options,
}: SelectInputProps) {
    const src = setIcon(active);
    return (
        <>
            <div className="z-50">
                <Listbox
                    onChange={(value: string) => {
                        onChange(value);
                    }}
                    value={active}
                >
                    <Listbox.Button>
                        <div className="w-82  lg:w-82 md:w-60   h-14 p-4 bg-white border border-cyan-600   rounded-sm   justify-start items-center gap-1 inline-flex">
                            <div className="w-64 h-6 justify-start -mt-1 hover:cursor-pointer items-center gap-2 inline-flex">
                                {active ? (
                                    <>
                                        {src && (
                                            <Image
                                                alt=""
                                                height={25}
                                                width={25}
                                                src={src}
                                            />
                                        )}
                                    </>
                                ) : (
                                    initialOption?.icon
                                )}
                                <div className="text-neutral-800 text-lg font-bold  leading-normal">
                                    {active}
                                </div>
                            </div>
                            <Image
                                src={"/Icons/Header/dropdownBlack.svg"}
                                className="w-6 h-6 relative"
                                alt=""
                                height={25}
                                width={25}
                            />
                        </div>
                    </Listbox.Button>
                    <Transition
                        enter="transition duration-100 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-75 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                    >
                        <Listbox.Options
                            className={"absolute z-50 border border-cyan-600"}
                        >
                            {options?.map((option) => (
                                <Listbox.Option
                                    value={option.value}
                                    key={option.value}
                                    disabled={option.numberOfVideos === "0"}
                                >
                                    <div className="w-82 lg:w-80  h-16 p-3  z-50 bg-zinc-50 rounded-sm justify-center items-start gap-1 inline-flex hover:cursor-pointer hover:bg-gray-100">
                                        <div
                                            className={twMerge(
                                                "w-full self-stretch p-4 bg-zink-50 rounded-sm  justify-start items-center gap-1 inline-flex",
                                                option.numberOfVideos === "0" &&
                                                    "opacity-50",
                                            )}
                                        >
                                            <div className="w-6 h-6 justify-center items-center flex">
                                                {option.icon}
                                            </div>
                                            <div className="grow shrink basis-0 h-6 justify-start items-center gap-1 flex">
                                                <div className="text-neutral-800 text-lg font-bold  leading-normal">
                                                    {option.title}
                                                    <div className="p-1 mx-2 rounded flex-col justify-start items-start gap-1 inline-flex bg-zinc-100">
                                                        <p className="self-stretch text-neutral-800 text-xs  leading-none">
                                                            {option.numberOfVideos}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-6 h-6 relative" />
                                        </div>
                                    </div>
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </Listbox>
            </div>
        </>
    );
}
